import { useModalStore } from '../store';

export default function useDeleteModal() {
  const { modalStore, setModalStore } = useModalStore();

  return ({
    itemId, message, objectName, deleteItem,
  }) => {
    setModalStore({
      ...modalStore,
      deleteModal: {
        isOpen: true,
        objectName,
        deleteRequest: () => deleteItem(itemId),
        id: itemId,
        message,
      },
    });
  };
}
